import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSwimmer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    color="currentColor"
    {...props}
  >
    <path d="M17 9.28a2 2 0 1 0-2-2 2 2 0 0 0 2 2M2.71 13.92a3 3 0 0 1 .57.25 4.06 4.06 0 0 0 4.1 0 2.62 2.62 0 0 1 2.56 0l.21.1a4.14 4.14 0 0 0 3.87-.13 2.62 2.62 0 0 1 2.56 0 4.25 4.25 0 0 0 2.08.56 4 4 0 0 0 2-.56 3 3 0 0 1 .57-.25 1 1 0 1 0-.52-1.89 4.8 4.8 0 0 0-1 .44 2.1 2.1 0 0 1-2.1 0 4.62 4.62 0 0 0-4.54 0 3 3 0 0 1-.29.12L14.34 11a.8.8 0 0 0 .09-.15 1 1 0 0 0 .12-.16 1.3 1.3 0 0 0 0-.19 1 1 0 0 0 0-.19 1 1 0 0 0 0-.18 1 1 0 0 0 0-.19 2 2 0 0 0-.1-.17.7.7 0 0 0-.1-.16l-3.07-3.33a1.1 1.1 0 0 0-.28-.22.8.8 0 0 0-.21 0 .5.5 0 0 0-.17 0A.9.9 0 0 0 10.2 6L6.66 7.32a1 1 0 0 0-.6 1.28 1 1 0 0 0 1.28.6l2.93-1.07 2 2.12-1.9 1.9a4.62 4.62 0 0 0-3.94.28 2.1 2.1 0 0 1-2.1 0 4.8 4.8 0 0 0-1-.44 1 1 0 1 0-.58 1.91Zm18 3.09a4.8 4.8 0 0 0-1 .44 2.1 2.1 0 0 1-2.1 0 4.62 4.62 0 0 0-4.54 0 2.11 2.11 0 0 1-2.12 0 4.62 4.62 0 0 0-4.54 0 2.1 2.1 0 0 1-2.1 0 4.8 4.8 0 0 0-1-.44 1 1 0 1 0-.58 1.91 3 3 0 0 1 .57.25 4.06 4.06 0 0 0 4.1 0 2.62 2.62 0 0 1 2.56 0 4.15 4.15 0 0 0 4.12 0 2.62 2.62 0 0 1 2.56 0 4.25 4.25 0 0 0 2.08.56 4 4 0 0 0 2-.56 3 3 0 0 1 .57-.25 1 1 0 1 0-.58-1.92Z" />
  </svg>
);
export default SvgSwimmer;
